import TextableModel from '../TextableModel';
import PropertyDescriptor from '../../utils/PropertyDescriptor';
export default class Model extends TextableModel {
    text = new PropertyDescriptor("", '文本', "文本", "text", "#anticon-text", {
        enabled: false
    });
    deadline = new PropertyDescriptor(new Date().valueOf() + 86400000, '截至日期', "倒计时", "datetime", "#anticon-timer", {

    });
    countDownFormat = new PropertyDescriptor("HHt:mm:ss", '时间格式', "倒计时", "enum", "#anticon-timer1", {
        catalogIndex: 20,
        values: [
            new PropertyDescriptor("HHt:mm:ss", '小时:分钟:秒', undefined, "string"),
            new PropertyDescriptor("DD", '天', undefined, "string"),
            new PropertyDescriptor("DD天 HH小时", '天 小时', undefined, "string"),
            new PropertyDescriptor("custom", '自定义', undefined, "string"),
        ]
    });
    countDownFormatCustom = new PropertyDescriptor("DD天 HH:mm:ss", '时间格式', "倒计时", "text", "#anticon-text", {
        placeholder: 'eg:DDt HH:mm:ss',
        visible: false
    });
    isAutoRefresh = new PropertyDescriptor(true, '自动刷新', "倒计时", "bool", "#anticon-shuaxin5");
    autoRefreshInterval = new PropertyDescriptor(1, '间隔(秒)', "倒计时", "double", "#anticon-home5", {
        minValue: 1
    });
    constructor(opts = {}) {
        super();
        this.defineAllProperties();

        this.backgroundColor = "transparent";
        this.borderWidth = 0;
        this.fontSize = 24;
        this.width = 200
        for (var p in opts) {
            this[p] = opts[p];
        }
    }

    getType() {
        return "CountDownModel";
    }
    onPropertyValueChanged(name, valOld, valNew, subName) {
        super.onPropertyValueChanged(name, valOld, valNew, subName);
        if (subName === undefined) {
            switch (name) {
                case "isAutoRefresh":
                    this.setPropertyVisible("autoRefreshInterval", valNew)
                    break;
                case "countDownFormat":
                    this.setPropertyVisible("countDownFormatCustom", valNew === "custom")
                    break;
            }
        }

    }
}
